import React, { Component } from 'react';
import ReCAPTCHA from "react-google-recaptcha";

class Recaptcha extends Component {
  constructor(props, context) {
    super(props, context);
    this.onLoadRecaptcha = this.onLoadRecaptcha.bind(this);
    this.verifyCallback = this.verifyCallback.bind(this);
    const recaptchaRef = React.createRef();
  }
  componentDidMount() {
    if (this.recaptchaRef) {
        console.log("started, just a second...")
        this.recaptchaRef.reset();
    }
  }
  onLoadRecaptcha() {
      if (this.recaptchaRef) {
          this.recaptchaRef.reset();
      }
  }
  verifyCallback(recaptchaToken) {
    // Here you will get the final recaptchaToken!!!  
    console.log(recaptchaToken, "<= your recaptcha token")
    if(recaptchaToken){
      this.props.checkVerification(true);
    }
  }
  render() {
    return (
      <div>
        <ReCAPTCHA
          ref={this.recaptchaRef}
          size="normal"
          theme="light"
          sitekey={process.env.recaptchaSiteKey}
          onChange={this.verifyCallback}
          onExpired={this.onLoadRecaptcha}
          onErrored={this.onLoadRecaptcha}
        />
      </div>
    );
  };
};

export default Recaptcha;